module.exports = __webpack_public_path__ + "static/media/intro-photowall-28.d8a78bec.jpg";